import React, { useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'sonner';
import { AuthContext } from '../App';
import ComicBlueprint from './ComicBlueprint';

const StudioLanding = () => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();

  // Check if a project was passed from Dashboard Edit or other routes
  const passedProject = location.state?.project || null;

  // Check if this is a "New Project" request (from Dashboard "+ New Artwork" button)
  const isNewProject = location.state?.newProject || false;

  // Default demo project for guests (and fresh authenticated users)
  const demoProject = {
    title: 'Untitled Comic',
    pageWidth: 1200,
    pageHeight: 1600,
    orientation: 'portrait',
    panelCount: 4,
    story: '',
    artStyle: '',
    characterDescriptions: ''
  };

  const handleAuthRequired = (message) => {
    toast.info(message);
    navigate('/login', { state: { returnTo: '/comica' } });
  };

  // If newProject flag is set, always use a fresh demoProject (ignore any session/passed data)
  const projectToLoad = isNewProject ? demoProject : (passedProject || demoProject);

  return (
    <ComicBlueprint
      renderMode="landing"
      demoProject={projectToLoad}
      onAuthRequired={handleAuthRequired}
      forceNewProject={isNewProject}
    />
  );
};

export default StudioLanding;
